import React from 'react'
import { IconS24Bin24, IconS24Pen24, IconS24Plus24 } from '@is24/cosma-ui-icons'
import { AttachmentDataWithRequiredAttachment } from '../../../../../../../../../../@types/types'
import { CircularActionButton } from './CircularActionButton'
import styles from './CarouselActionButtons.module.css'

interface CarouselActionButtonsProps {
  currentAttachment: AttachmentDataWithRequiredAttachment
  dropzoneId: string
  onEditClick: (attachment: AttachmentDataWithRequiredAttachment) => void
  onAddClick: () => void
  onDeleteClick?: (attachment: AttachmentDataWithRequiredAttachment) => void
}

export const CarouselActionButtons: React.FC<CarouselActionButtonsProps> = ({
  currentAttachment,
  dropzoneId,
  onEditClick,
  onAddClick,
  onDeleteClick,
}) => {
  const handleEditClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onEditClick(currentAttachment)
  }

  const handleAddClick = () => {
    onAddClick()
  }

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onDeleteClick?.(currentAttachment)
  }

  return (
    <div className={styles.buttonsContainer}>
      <CircularActionButton
        onClick={handleEditClick}
        icon={<IconS24Pen24 width={16} height={16} />}
        ariaLabel='Edit picture'
      />
      {onDeleteClick ? (
        <CircularActionButton
          onClick={handleDeleteClick}
          icon={<IconS24Bin24 width={16} height={16} />}
          ariaLabel='Delete picture'
        />
      ) : (
        <CircularActionButton
          id={dropzoneId}
          onClick={handleAddClick}
          icon={<IconS24Plus24 width={16} height={16} />}
          ariaLabel='Add picture'
        />
      )}
    </div>
  )
}
